export default {
    enumList: null,
    changeAssign: {
        visibale: false,
        customerGroupCode: ''
    }
}
